import { useMemo } from "react";
import { useCreateContractWizardStore } from "@/stores/createContractWizardStore";
import { useCreateOrderFromContractStore } from "@/stores/createOrderFromContractStore";
import { useTradeLock } from "@/hooks/useTradeLock";

/**
 * Drop-in replacements for the wizard stores' `open` actions that respect the company trade lock.
 *
 * Always prefer these over reading `open` off the store directly, so a new entry point cannot silently skip
 * the lock check. Memoised because callers pass the result into `useMemo` dependency arrays (see the table
 * column defs in `pages/Contracts/ContractList`), where a fresh identity each render would defeat the memo.
 */
export function useOpenCreateContract() {
  const open = useCreateContractWizardStore((s) => s.open);
  const { guardTradeLock } = useTradeLock();
  return useMemo(() => guardTradeLock(open), [guardTradeLock, open]);
}

export function useOpenCreateOrder() {
  const open = useCreateOrderFromContractStore((s) => s.open);
  const { guardTradeLock } = useTradeLock();
  return useMemo(() => guardTradeLock(open), [guardTradeLock, open]);
}
